<template>
  <div v-if="loading">
    <Spinner/>
  </div>
  <div v-else-if="user" class="text-sm grid grid-cols-10 pb-10 gap-2 sm:gap-5 md:gap-10">
    <div class="col-span-10 sm:col-span-3 md:col-span-2 lg:col-span-2 relative">
      <!-- Add profile photo section -->
      <div class="relative group">
        <img v-if="user.photo" :src="user.photo" class="w-full" alt="Profile photo">
        <div v-else>No photo. Add one below!</div>
        <div class="mt-2">
          <button v-if="showPhotoSaveButton" class="g--button  w-full g--button--green" @click="uploadPhoto">
            Save
          </button>
          <div v-if="saved" class="mt-2">
            <p>Photo saved!</p>
          </div>

          <button @click="triggerFileInput" class="mt-2 w-full g--button">
            <span v-if="!showPhotoSaveButton">
              <span v-if="user.photo">Change</span><span v-else>Add a</span> profile photo
            </span>
            <span v-else>Try another photo</span>
          </button>
          <p class="text-xs mt-4 tracking-wide">Please upload a JPG file &lt; 2mb.</p>
        </div>
        <input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" class="hidden">
      </div>
    </div>

    <div class="col-span-10 md:col-span-8">
      <div class="grid grid-cols-6 gap-2 sm:gap-5 mb-10">
        <div class="col-span-6 sm:col-span-3">
          <div class="text-xl mb-4">About you</div>
          <label class="g--label mb-1">Full name *</label>
          <input type="text" required v-model="user.fullName" class="g--input">
          <div class="mt-4">
            <label class="g--label mb-1">Presentation</label>
            <editor v-model="user.presentation"/>
          </div>
          <div class="mt-4">
            <label class="g--label mb-1">
              Location
            </label>
            <input type="text" v-model="user.shortLocation" class="g--input" placeholder="e.g. London, UK">
          </div>

          <div class="mt-4">
            <label class="g--label mb-2 g--label--flex items-center">
              YouTube Video URL
              <tooltip>

              </tooltip>
            </label>
            <input type="url" v-model="user.youtubePresentationVideo" class="g--input z-10 relative"
                   placeholder="https://www.youtube.com/watch?v=...">
          </div>

          <div class="p-4 pt-2 mt-4 rounded relative bg-gradient-to-tr from-[#E7EBF6] via-[#FFF3D3] to-[#FFDDC9]">
            <div v-if="user.subscriptionTier != 'guru'" class="flex items-center absolute bg-white bg-opacity-50 justify-center top-0 left-0 w-full h-full">
              <a href="/pricing" class=" text-center g--button">
                Upgrade to the Guru plan<br>to add your social links</a>
            </div>
            <div class="g--tag bg-white mt-2">
              <span class="mr-2 inline-block">⭐️ </span> Guru plan
            </div>
            <label for="instagramHandle" class="g--label g--label--flex mt-4 mb-2 items-center">
              Instagram handle
          </label> <input v-model="user.instagramHandle" type="text" id="instagramHandle" name="fields[instagramHandle]" class="form-input  block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"> <label for="facebookHandle" class="g--label g--label--flex mt-4 mb-2 items-center">
              Facebook handle
          </label> <input v-model="user.facebookHandle" type="text" id="facebookHandle" name="fields[facebookHandle]" class="form-input  block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"> <label for="linkedinHandle" class="g--label g--label--flex mt-4 mb-2 items-center">
              LinkedIn handle
          </label> <input v-model="user.linkedinHandle" type="text" id="linkedinHandle" name="fields[linkedinHandle]" class="form-input  block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"> <label for="tiktokHandle" class="g--label g--label--flex mt-4 mb-2 items-center">
              TikTok handle
          </label> <input v-model="user.tiktokHandle" type="text" id="tiktokHandle" name="fields[tiktokHandle]" class="form-input  block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"> <label for="xTwitterHandle" class="g--label g--label--flex mt-4 mb-2 items-center">
              X / Twitter handle
          </label> <input v-model="user.xTwitterHandle" type="text" id="xTwitterHandle" name="fields[xTwitterHandle]" class="form-input  block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"> <label for="website" class="g--label g--label--flex mt-4 mb-2 items-center">
              Your website URL
          </label> <input v-model="user.website" type="url" id="website" name="fields[website]" class="form-input  block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"></div>


        </div>


        <div class="col-span-6 sm:col-span-3">
          <div class="text-xl mb-4">Experience</div>

          <div class="mt-4">
            <fieldset>
              <legend class="g--label">Select the types of yoga you teach (5 max):</legend>
              <div class="grid grid-cols-2">
                <div class="mt-2 col-span-1 gap-x-2" v-for="type in user.allStyles">
                  <div class="flex items-start">
                    <div class="flex items-center h-5">
                      <input @change="checkTags();" v-model="type.checked" :id="type.id"
                             :disabled="maxReached && !type.checked" :value="type.id" name="fields[yogaStyles][]"
                             type="checkbox"
                             class="cursor-pointer form-checkbox h-4 w-4 text-teal transition duration-150 ease-in-out">
                    </div>
                    <div class="ml-3 text-sm leading-5">
                      <label
                          :class="{ 'text-gray-400': maxReached && !type.checked, 'text-gray-700': !maxReached || type.checked }"
                          :for="type.id" class="cursor-pointer font-medium">{{ type.title }}</label>
                    </div>
                  </div>
                </div>

              </div>
            </fieldset>

            <div class="mt-4">
              <label class="g--label mb-1">
                Qualifications
              </label>
              <input type="text" v-model="user.qualifications" class="g--input" placeholder="">
            </div>
          </div>

        </div>

      </div>
      <div class="mb-2 text-red" v-if="user.fullName == ''">
        Please enter your full name
      </div>
      <button class=" g--button w-full" :class="{
                  'g--button--green': !isSaving,
                  'g--button--gray opacity-75 cursor-not-allowed': isSaving  || requiredMissing
                }" :disabled="isSaving || requiredMissing" @click="saveProfile">
        {{ saveButtonText }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import Spinner from './Spinner.vue';
import Editor from './Editor.vue'
import Tooltip from './Tooltip.vue'


const photo = ref('/img/profile-default.svg'); // Replace with actual default photo path
const fileInput = ref(null);

const loading = ref(true);
const triggerFileInput = () => {
  fileInput.value.click();
};

const showPhotoSaveButton = ref(false);
const saved = ref(false);

const user = ref({});

const maxReached = ref(false);
const saveButtonText = ref('Save changes');
const isSaving = ref(false);

const requiredMissing = ref(true);

onMounted(() => {
  loadUser();
});

watch(
    () => user.value.fullName,
    (newValue) => {
      if (newValue && newValue.trim() !== '') {
        requiredMissing.value = false;
      } else {
        requiredMissing.value = true;
      }
    }
);


const loadUser = async () => {
  const response = await fetch(`/api/teachers/self`);
  user.value = await response.json();

  loading.value = false;
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    // Create a temporary URL for preview
    user.value.photo = URL.createObjectURL(file);
    user.value.photoFile = file;
    showPhotoSaveButton.value = true;
  }
};

// Implement photo upload function
const uploadPhoto = async () => {
  const reader = new FileReader();
  reader.readAsDataURL(user.value.photoFile);

  reader.onload = e => {

    const formData = new FormData();
    formData.append('photo', user.value.photoFile);
    formData.append('userId', user.value.userId);
    formData.append(csrfTokenName, csrfTokenValue);



    fetch('?action=users/save-user', {
      method: 'post',
      headers: {
        // 'Content-type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },

      processData: false,
      contentType: false,
      body: formData
      //   body: JSON.stringify(data),
    })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          console.log(response);
          if (response.errors && response.errors.photo) {
            alert('Your photo is too big. Please upload a file < 2mb.');
          }
          showPhotoSaveButton.value = false;
          saved.value = true;
          setTimeout(() => {
            saved.value = false;
          }, 2000);
        })
        .catch((error) => {
          alert('Your photo is too big. Please upload a file < 2mb.');
          // that.uploading = false;
        });
  }

};

const checkTags = () => {
  const checkedCount = user.value.allStyles.filter(style => style.checked).length;
  maxReached.value = checkedCount >= 5;
};


const saveProfile = async () => {
  console.log(user.value.allStyles);
  isSaving.value = true;
  saveButtonText.value = 'Saving...';
  const formData = new FormData();
  formData.append('fullName', user.value.fullName);
  formData.append('fields[presentation]', user.value.presentation);
  formData.append('fields[shortLocation]', user.value.shortLocation);
  formData.append('fields[youtubePresentationVideo]', user.value.youtubePresentationVideo);
  formData.append('fields[qualifications]', user.value.qualifications);
  formData.append('fields[instagramHandle]', user.value.instagramHandle);
  formData.append('fields[facebookHandle]', user.value.facebookHandle);
  formData.append('fields[linkedinHandle]', user.value.linkedinHandle);
  formData.append('fields[tiktokHandle]', user.value.tiktokHandle);
  formData.append('fields[xTwitterHandle]', user.value.xTwitterHandle);
  formData.append('fields[website]', user.value.website);
  const selectedStyles = user.value.allStyles.filter(style => style.checked).map(style => style.id);
  selectedStyles.forEach(styleId => {
    formData.append('fields[yogaStyles][]', styleId);
  });
  if (selectedStyles.length == 0) {
    formData.append('fields[yogaStyles]', '[]');
  }
  formData.append('userId', user.value.userId);
  formData.append(csrfTokenName, csrfTokenValue);

  fetch('?action=users/save-user', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        saveButtonText.value = 'Saved!';
        setTimeout(() => {
          saveButtonText.value = 'Save changes';
          isSaving.value = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error saving profile:', error);
        saveButtonText.value = 'Save changes';
        isSaving.value = false;
      });
};
</script>